export const PAYMENT_NAMES = {
  yappy: 'Yappy -',
  comercial: 'Cuenta a crédito',
  crédito: 'Tarjeta',
  puntos: 'Puntos Gordos:',
  regalo: 'Tarjeta de Regalo:',
  cmf: 'CMF',
  ach: 'Transferencia ACH:',
  pendiente: 'Pendiente de pago: ',
}

// export const paymentName = Object.freeze(names)
